import React from 'react';
import propTypes from 'prop-types';

const TireFinderShell = ({ children }) => (
  <div className="cmp-tire-finder-shell" data-testid="tireFinderShell">
    <p className="cmp-tire-finder-shell__heading">
      Shop Tires
    </p>
    <div className="cmp-tire-finder-shell__inner">
      {children}
    </div>
    <div className="cmp-tire-finder-shell__link-wrapper">
      <a href="/finder/results?searchMethod=searchTrailerTires" className="cmp-secondary-link">
        Shop Trailer Tires
      </a>
    </div>
  </div>
);

TireFinderShell.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
  ]),
};

export { TireFinderShell };
